<script lang="ts">
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import GameCards from 'src/components/main/games/components/game-cards/GameCards.svelte'
    import Audience from 'src/components/main/games/components/audience/Audience.svelte'
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Android Apps by Realis</title>
    <meta name="description" content="In our gaming ecosystem user uses a tokenized in-game currency (token), which is a display of the player's achievements, which he can spend on unique actions."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <GameCards/>
        <Audience/>
        <VisitCommunity/>
    </svelte:fragment>
</MainLayout>
